import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navbar.css';

function Navbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);
  const lastScrollY = useRef(0);
  const location = useLocation();
  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      setScrolled(currentY > 80);
      if (currentY > lastScrollY.current && currentY > 120 && !mobileMenuOpen) {
        setHidden(true);
      } else {
        setHidden(false);
      }
      lastScrollY.current = currentY;
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [mobileMenuOpen]);

  useEffect(() => {
    document.body.classList.toggle('nav-open', mobileMenuOpen);
  }, [mobileMenuOpen]);

  useEffect(() => {
    setMobileMenuOpen(false);
    setScrolled(false);
    setHidden(false);
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <nav className={`navbar ${scrolled ? 'scrolled' : ''} ${transparent ? 'transparent' : ''} ${hidden ? 'hidden' : ''}`}>
      <div className="container navbar-container">

        {/* Nav links — RIGHT */}
        <ul className="nav-links">
          <li><Link to="/overview">About</Link></li>
          <li><Link to="/treatments">Treatments</Link></li>
          <li><Link to="/enhancements">Enhancements</Link></li>
          <li><Link to="/providers">Medical Aesthetics & Longevity</Link></li>
          <li><Link to="/products">Products</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li className="nav-book"><Link to="/appointments">Book</Link></li>
        </ul>

        {/* Mobile hamburger */}
        <button
          className={`mobile-menu-toggle ${mobileMenuOpen ? 'open' : ''}`}
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        {/* Mobile full-screen menu */}
        <ul className={`nav-mobile ${mobileMenuOpen ? 'open' : ''}`}>
          <li><Link to="/overview">About</Link></li>
          <li><Link to="/treatments">Treatments</Link></li>
          <li><Link to="/enhancements">Enhancements</Link></li>
          <li><Link to="/providers">Medical Aesthetics & Longevity</Link></li>
          <li><Link to="/products">Products</Link></li>
          <li><Link to="/contact">Contact</Link></li>
          <li className="nav-book"><Link to="/appointments">Book</Link></li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;
